import React, { createContext, useState } from 'react';

const MakeAndModelContext = createContext(null);

function MakeAndModelContextProvider(props) {
  const [makeAndModel, setMakeAndModel] = useState(null);

  return (
    <MakeAndModelContext.Provider
      value={{
        makeAndModel: makeAndModel || JSON.parse(localStorage.getItem('current_make_model')),
        setMakeAndModel: setMakeAndModel,
      }}
    >
      {props.children}
    </MakeAndModelContext.Provider>
  );
}

export { MakeAndModelContextProvider, MakeAndModelContext as makeAndModelContext };
